export default {"src":"/_next/static/media/audio_grey.a8df652e.svg","height":16,"width":10};